var typeAhead = require('./typeAhead');

module.exports = function () {
    var $searchControls = $('.search-control');       
    
    if (!$searchControls.length) {
      return;
    }    

    $searchControls.each(function () {
        $searchControl = $(this);        
        typeAhead($searchControl, 'searchSuggestionsCache', '/icfapi/searchsuggestions/getsuggestions');

        $searchControl.find('.search-control__clear-search-btn').click(function (e) {
            e.preventDefault();
            var $searchControl = $(e.target).closest('.search-control');
            var $searchInput = $searchControl.find('.search-control__search-input');
            var $typeAheadHidden = $searchControl.find('.search-control__type-ahead-hidden-text');
            var $typeAheadVisible = $searchControl.find('.search-control__type-ahead-visible-text');

            $searchInput.val('');
            $typeAheadHidden.text('');
            $typeAheadVisible.text('');
            $searchControl.find('.search-control__search-suggestions-wrapper--active').removeClass('search-control__search-suggestions-wrapper--active');
            $searchInput.focus();
        });

        $searchControl.find('.search-control__search-btn').click(function (e) {
            var $searchControl = $(e.target).closest('.search-control');          
            $searchControl.find('.search-control__submit').click();
        });
    });                         
};